var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00D395",
    d: "M6.55 15.831a1.15 1.15 0 0 1-.55-.98v-2.23a.48.48 0 0 1 .189-.382a.48.48 0 0 1 .53-.032l5.23 2.933a.96.96 0 0 1 .48.828v2.311a.59.59 0 0 1-.444.56a.57.57 0 0 1-.435-.069zm7.49-4.235c.293.172.531.486.531.828v4.689c0 .139-.132.267-.252.334l-.972.635c-.013.008-.046.014-.061.018v-2.604a.94.94 0 0 0-.449-.823L8.143 11.98V9.04c0-.085.03-.167.073-.24a.477.477 0 0 1 .654-.172zm2.198-3.464a.96.96 0 0 1 .476.83v6.85c0 .14-.077.27-.2.336l-1.085.565v-4.77c0-.336-.135-.648-.422-.821l-4.721-2.79V5.623c0-.086.038-.168.079-.241a.48.48 0 0 1 .654-.174z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComp);
export default __webpack_public_path__ + "static/media/comp.85ee0b49ca878d903c3cac26fbbc7955.svg";
export { ForwardRef as ReactComponent };